<template>
  <div class="chat-history-edit-message-history">
    <Modal
      v-if="modalFlag"
      :class="'modal--dialog modal--booking'"
      :header="false"
      :booking-header="true"
      @close-modal="setShowMessageEdit(false)"
    >
      <template #custom-header>
          <div class="modal-header">
            <h2 class="modal-heading">Edit Message</h2>
            <button type="button" @click="closeMessageEdit()">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="13.261"
                height="13.26"
                viewBox="0 0 13.261 13.26"
              >
                <g transform="translate(3.671 -2.369) rotate(45)">
                  <line
                    x2="16.752"
                    transform="translate(8.456 -4.106) rotate(90)"
                    fill="none"
                    stroke-width="2"
                  />
                  <line
                    x2="16.752"
                    transform="translate(0.079 4.271)"
                    fill="none"
                    stroke-width="2"
                  />
                </g>
              </svg>
              <span class="close-text">Close</span>
            </button>
            <br />
          </div>
      </template>
      <section class="section-container">

        <el-row>
            <vue-editor 
                :editor-toolbar="customToolbar"
                v-model="chatMessage"
                @text-change="onContentChange"
                ref="editor"/>
        </el-row>
      </section>
      <br />

      <ModalFooter
        name="chat-history-edit"
        can-submit
        :submit-only="true"
        :show-submit-button-icon="false"
        :disable-on-submit="submitBtnDisabled"
        submit-label="Save"
        submit-class="confirm-save-chat"
        @on-submit="submitEdit"
      />
    </Modal>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Modal from '@/components/Templates/Modal';
import ModalFooter from '@/components/Templates/ModalFooter';
import { VueEditor } from "vue2-editor";
import ChatHistory from '@/mixins/chatHistory';

export default {
  mixins: [ChatHistory],
  props: {
    modalShow: {
      type: Boolean,
      default: false
    },
  },
  components: { 
    Modal,
    ModalFooter,
    VueEditor,
  },
  data: () => {
    return {
      modalFlag: false,
      chatMessage: '',
      submitBtnDisabled: true,
      submittingEdit: false,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: ['#000000', '#00A4D9', '#36B37E', '#FF5630', '#FF991F'] }]
      ],
    };
  },
  watch: {
    modalShow(value) {
      this.modalFlag = value;
      this.chatMessage = this.currentChatEditMessage;
      if (this.modalFlag) {
        // do something when modal is showing
      } else {
        this.chatMessage = '';
        this.submitBtnDisabled = true;
        this.setCurrentChatHistoryMeta({});
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['setShowMessageEdit']),
    ...mapMutations('chatHistory', ['setCurrentChatHistoryMeta']),
    closeMessageEdit() {
      this.setShowMessageEdit(false);
    },
    async submitEdit() {
      this.setSubmittingEdit(true);
      const params = {
        lessonId: this.lessonId,
        messageId: this.currentChatEditId,
        message: this.chatMessage,
      };

      const response = await this.executeUpdateChatMessage(params);
      this.closeMessageEdit();
      if (response?.rows > 0) {
        console.log('Modal message edit successful');
      } else {
          console.log('Modal message edit error');
      }
      
      this.setSubmittingEdit(false);
    },
    onContentChange() {
        if (this.submittingEdit) {
            console.log('Do not allow resubmission, if we are currently posting an update.');
            return;
        }
        const isDifferent = this.chatMessage !== this.currentChatEditMessage;
        if (isDifferent) {
            this.submitBtnDisabled = false;
        } else {
            this.submitBtnDisabled = true;
        }
    },
    setSubmittingEdit(status) {
        this.submittingEdit = status;
        this.submitBtnDisabled = status;
    }
  },
  computed: {
    ...mapState('chatHistory', ['lessonId', 'currentChatEditId', 'currentChatEditMessage']),
  },
};
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
